import { get } from '../api/axiosClient'
import {
    BusinessChainDTOListApiResponse,
    CommerceResultDetail,
    CommerceSearchResultPagedListPagedApiResponse,
} from '../../types/__generated__/companies'

export const fetchBusinessChains = async (): Promise<BusinessChainDTOListApiResponse> => {
    const url = '/api/companies/availablechains'

    const response = await get(url)
    return response.data
}

export const fetchChamberOfCommerceQuery = async (
    searchTerm: string
): Promise<CommerceSearchResultPagedListPagedApiResponse> => {
    const url = `/api/companies/searchkvk?SearchTerm=${searchTerm}`

    const response = await get(url)
    return response.data
}

export const fetchChamberOfCommerceDetails = async (id: string): Promise<CommerceResultDetail> => {
    const url = `/api/companies/kvkdetails?id=${id}`

    const response = await get(url)
    return response.data?.data
}
